module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "aria-labelledby": "headertoc01",
      "epub:type": "toc",
      "id": "toc",
      "role": "doc-toc"
    }
  }, [_c('header', {
    attrs: {
      "id": "headertoc01"
    }
  }, [_c('h1', {
    staticClass: "ctfm"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "vi",
      "id": "pvi",
      "role": "doc-pagebreak"
    }
  }), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "vii",
      "id": "pvii",
      "role": "doc-pagebreak"
    }
  }), _vm._v("CONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "tocfmf"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chifriedmancapitalism0007#fore"
    }
  }, [_vm._v("Foreword by Binyamin Appelbaum")])]), _vm._v(" "), _c('p', {
    staticClass: "tocfm"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chifriedmancapitalism0008#pref-2002"
    }
  }, [_vm._v("Preface, 2002")])]), _vm._v(" "), _c('p', {
    staticClass: "tocfm"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chifriedmancapitalism0009#pref-1982"
    }
  }, [_vm._v("Preface, 1982")])]), _vm._v(" "), _c('p', {
    staticClass: "tocfm"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chifriedmancapitalism0010#pref-1962"
    }
  }, [_vm._v("Preface, 1962")])]), _vm._v(" "), _c('p', {
    staticClass: "tocf"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chifriedmancapitalism0012#intro"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chifriedmancapitalism0013#ch01"
    }
  }, [_c('b', [_vm._v("1")]), _vm._v("   The Relation between Economic Freedom and Political Freedom")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chifriedmancapitalism0014#ch02"
    }
  }, [_c('b', [_vm._v("2")]), _vm._v("   The Role of Government in a Free Society")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chifriedmancapitalism0015#ch03"
    }
  }, [_c('b', [_vm._v("3")]), _vm._v("   The Control of Money")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chifriedmancapitalism0016#ch04"
    }
  }, [_c('b', [_vm._v("4")]), _vm._v("   International Financial and Trade Arrangements")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "viii",
      "id": "pviii",
      "role": "doc-pagebreak"
    }
  }), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chifriedmancapitalism0017#ch05"
    }
  }, [_c('b', [_vm._v("5")]), _vm._v("   Fiscal Policy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chifriedmancapitalism0018#ch06"
    }
  }, [_c('b', [_vm._v("6")]), _vm._v("   The Role of Government in Education")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chifriedmancapitalism0019#ch07"
    }
  }, [_c('b', [_vm._v("7")]), _vm._v("   Capitalism and Discrimination")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chifriedmancapitalism0020#ch08"
    }
  }, [_c('b', [_vm._v("8")]), _vm._v("   Monopoly and the Social Responsibility of Business and Labor")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chifriedmancapitalism0021#ch09"
    }
  }, [_c('b', [_vm._v("9")]), _vm._v("   Occupational Licensure")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chifriedmancapitalism0022#ch10"
    }
  }, [_c('b', [_vm._v("10")]), _vm._v("   The Distribution of Income")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chifriedmancapitalism0023#ch11"
    }
  }, [_c('b', [_vm._v("11")]), _vm._v("   Social Welfare Measures")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chifriedmancapitalism0024#ch12"
    }
  }, [_c('b', [_vm._v("12")]), _vm._v("   The Alleviation of Poverty")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chifriedmancapitalism0025#ch13"
    }
  }, [_c('b', [_vm._v("13")]), _vm._v("   Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbmf"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chifriedmancapitalism0026#fn_notes"
    }
  }, [_vm._v("Footnotes")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chifriedmancapitalism0027#index"
    }
  }, [_vm._v("Index")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d676630","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-friedman-capitalism-0006.vue
// module id = 69
// module chunks = 0